import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-sof-toolbar',
  imports: [SharedModule, MatButtonModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './sof-toolbar.component.html',
})
export class SofToolbarComponent {
  constructor(
      private _router: Router,
  ) { }

  addNewSofRecord() {
    this._router.navigate(['vessels/sof/sof-entry']).then();
  }

  addNewSofTemplate() {
    this._router.navigate(['vessels/sof/sof-template']).then();
  }

}